import apiClient from './apiClient';

const Url = `/roles`;

export const getRoles = async (props) => {
    try{
        let response = await apiClient.get(`${Url}/list`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const getRolePermissions = async (props) => {
    try{
        let response = await apiClient.get(`${Url}/role-permission-list`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const getPermissions = async (props) => {
    try{
        let response = await apiClient.get(`${Url}/permissions`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const addRole = async (props, thisEvt) => {
    try{
        let body = {
            "name" : thisEvt?.roleName,
        }
        console.log("Add Role Body : ", body);
        let response = await apiClient.post(`${Url}/`, body);
        console.log('Add Role : ',response);
        if(response && response.status === 200) return response.data;
        return response;
    } catch(error) {
        console.log('error', error, error.response);
        return error;
    }
}

export const addRolePermission = async (props, thisEvt) => {
    try{
        let body = {
            "name" : thisEvt?.addRolePermissionName,
            "roleId" : thisEvt?.addRoleId,
            "permissionId" : thisEvt?.addPermissionId
        }
        console.log("Add Role Permission Body : ", body);
        let response = await apiClient.post(`${Url}/role-permission`, body);
        console.log('Add Role Permission : ',response);
        if(response && response.status === 200) return response.data;
        return response;
    } catch(error) {
        console.log('error', error, error.response);
        return error;
    }
}

export const deleteRole = async (Id,props) => {
    try{
        let response = await apiClient.delete(`${Url}/?roleId=${Id}`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const deleteRolePermission = async (ID ,props) => {
    try{
        let response = await apiClient.delete(`${Url}/role-permission?rolePermissionId=${ID}`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const setRolePermissions = async (props, roleId, permissionIds) => {
    try {
        const response = await apiClient.put(
            `${Url}/set-permissions`,
            { roleId, permissionIds },
        );
        if (response && response.status === 200) return response.data;
        return response;
    } catch (error) {
        return error;
    }
}
